import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';
import { buildNavItems, HORIZONTAL_NAV_CONFIG } from '../../shared/sidebar-nav.config';

export const navItems: NavItem[] = [
  {
    navCap: 'Home',
  },
  ...buildNavItems(HORIZONTAL_NAV_CONFIG),
];
